import React from 'react';

type HomePageProps = {
  appIconUrl: string;
  appStoreUrl: string;
};

export function HomePage({appIconUrl, appStoreUrl}: HomePageProps) {
  return (
    <main className="app">
      <div className="hero">
        <div className="hero-brand">
          <img className="hero-icon" src={appIconUrl} alt="Dashless app icon" />
          <p className="eyebrow">Dashless iOS App</p>
        </div>
        <h1 className="title">A cleaner driving dashboard for your iPhone.</h1>
        <p className="subtitle">
          Dashless gives you a full-screen speedometer, OBD2 telemetry, and premium
          odometer themes for EV, hybrid, gasoline, and diesel vehicles.
        </p>
        <div className="hero-actions">
          <a
            className="primary-button"
            href={appStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Download on the App Store
          </a>
        </div>
      </div>

      <section className="section">
        <h2>Why Dashless</h2>
        <div className="grid">
          <article className="card">
            <h3>Clear speed view</h3>
            <p>Large, glanceable speed display in KPH or MPH for everyday driving.</p>
          </article>
          <article className="card">
            <h3>OBD2 ready</h3>
            <p>Connect compatible OBD2 readers for richer telemetry and diagnostics data.</p>
          </article>
          <article className="card">
            <h3>Advanced themes</h3>
            <p>Unlock premium dashboard styles tuned for EV, hybrid, gasoline, and diesel.</p>
          </article>
        </div>
      </section>

      <section className="section">
        <h2>Feature highlights</h2>
        <ul className="feature-list">
          <li>GPS and OBD2 speed source support</li>
          <li>Live telemetry and ride-focused layouts</li>
          <li>Error code reading workflow with in-app unlock</li>
          <li>Timer Odometer and Advanced EV family themes</li>
          <li>Quick source status and freshness visibility</li>
        </ul>
      </section>

      <footer className="footer">
        <p>Dashless for iOS</p>
        <div className="footer-links">
          <a href="/ios-privacy">iOS Privacy Policy</a>
          <a href="/support">Support</a>
          <a href={appStoreUrl} target="_blank" rel="noopener noreferrer">
            App Store
          </a>
        </div>
      </footer>
    </main>
  );
}
